import {Component, Input, OnInit, OnChanges, SimpleChanges, } from '@angular/core';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { NgClass } from '@angular/common';
import { Subscription, } from 'rxjs';
import { ApplicationDialogService } from '../application-dialog-component/application-dialog.service';
import { PortalHotToastService } from '../portal-hot-toast-component/hot-toast.service';
import { AccreditationCreditFlow, ApplicationCreditFlow, ApplicationCreditFlowNodeDetail, DEFAULT_LIMIT, DEFAULT_OFFSET, } from '@portal-workspace/grow-shared-library';
import { FlexModule } from '@angular/flex-layout';
import { CustomContentLoaderComponent } from "../custom-content-loader-component/custom-content-loader.component";
import { CustomPaginatorComponent } from '../custom-paginator-component/custom-paginator/custom-paginator.component';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { loadingFor } from '@ngneat/loadoff';
import { DatePipe, AsyncPipe, } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormBuilder, FormControl, ReactiveFormsModule } from '@angular/forms';
import moment from 'moment';
import { TagBoxComponent } from '../message-box/tag-box.component';

@Component({
    selector: 'credit-flow-details',
    templateUrl: './credit-flow-details.component.html',
    styleUrls: ['./credit-flow-details.component.scss'],
    standalone: true,
    imports: [
      MatTableModule, 
      NgClass, 
      ExtendedModule, 
      FlexModule,
      CustomContentLoaderComponent,
      CustomPaginatorComponent,
      MatSortModule,
      DatePipe,
      AsyncPipe,
      MatButtonModule,
      MatInputModule,
      MatFormFieldModule,
      ReactiveFormsModule,
      TagBoxComponent,
    ]
})
export class CreditFlowDetailsComponent implements OnInit, OnChanges {
  @Input({required: true}) creditFlowResult!: (ApplicationCreditFlow |AccreditationCreditFlow) [];
  @Input({required: false}) flowData!: ApplicationCreditFlowNodeDetail[]; // use flowData as data source if it exists, otherwise use creditFlowResult

  subscriptions: Subscription[] = [];
  moment = moment;
  formControlSearch!: FormControl<string | null>;

  total = 0;
  limit = DEFAULT_LIMIT;
  offset = DEFAULT_OFFSET;
  filter = '';
  loader = loadingFor('tableLoading');
  sorts: { prop: string, dir: 'asc' | 'desc' } | null = null;
  dataSource: ApplicationCreditFlowNodeDetail[] = [];
  columnsToDisplay = ['creditFlowName', 'creditFlowNodeName', 'ruleMappingName', 'calculation', 'alert', 'alertStatus'];

  constructor(
    private formBuilder: FormBuilder,
    private toastService: PortalHotToastService,
    private dialogService: ApplicationDialogService,
  ) {
  }

  ngOnInit(): void {
    if (this.flowData && this.flowData.length) {
      this.dataSource = this.flowData;
    } else {
      this.dataSource = this.creditFlowResult.flatMap(result =>
        result.flow.map(node => ({
          ...node,
          creditFlowName: node.creditFlowName  // Attach creditFlowName to each node
        }))
      );
    }
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (this.flowData && this.flowData.length) {
      this.dataSource = this.flowData;
    } else {
      this.dataSource = this.creditFlowResult.flatMap(result =>
        result.flow.map(node => ({
          ...node,
          creditFlowName: node.creditFlowName  // Attach creditFlowName to each node
        }))
      );
    }
  }

  getColumnTitles(column: string): string {
    switch (column) {
      case 'creditFlowName': return 'Flow Name';
      case 'alertId': return 'Alert ID';
      case 'alert': return 'Alert';
      case 'alertStatus': return 'Status';
      case 'calculation': return 'Calculations';
      case 'creditFlowNodeName': return 'Flow Node';
      case 'ruleMappingName': return 'Rule';
      default: return column;
    }
  }
}
